__turbopack_context__.v({
  "JobCardInnerHeading": "bhTBga_JobCardInnerHeading",
  "JobPostCardBottom": "bhTBga_JobPostCardBottom",
  "addedon": "bhTBga_addedon",
  "cardCon": "bhTBga_cardCon",
  "cardConActive": "bhTBga_cardConActive",
  "cardConDiv": "bhTBga_cardConDiv",
  "cardLogoDiv": "bhTBga_cardLogoDiv",
  "cityname": "bhTBga_cityname",
  "cl": "bhTBga_cl",
  "cname": "bhTBga_cname",
  "companyAvatar": "bhTBga_companyAvatar",
  "jobCardLogo": "bhTBga_jobCardLogo",
  "jobHeaderBanner": "bhTBga_jobHeaderBanner",
  "jobHeaderBannerImg": "bhTBga_jobHeaderBannerImg",
  "jobHeaderLogoBox": "bhTBga_jobHeaderLogoBox",
  "jobHeaderLogoImg": "bhTBga_jobHeaderLogoImg",
  "jobHeaderWrap": "bhTBga_jobHeaderWrap",
  "jobtitlediv": "bhTBga_jobtitlediv",
  "textdiv": "bhTBga_textdiv",
  "underlinehover": "bhTBga_underlinehover",
});
